import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

console.log('MarketEmprende: ErrorBoundary.tsx cargado');

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    const { hasError, error } = this.state;
    if (hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-red-50 border border-red-200 rounded-2xl p-8 text-center">
            <h1 className="text-2xl font-bold text-red-900 mb-4">Algo ha salido mal</h1>
            <p className="text-red-700 mb-6">
              La aplicación ha encontrado un error inesperado durante el renderizado.
            </p>
            <div className="bg-white p-4 rounded-xl border border-red-100 text-left mb-6 overflow-auto max-h-48">
              <p className="text-xs font-mono text-red-600">
                {error?.toString()}
              </p>
            </div>
            <button
              onClick={() => window.location.reload()}
              className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-xl transition-colors"
            >
              Recargar aplicación
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
